export const HOME_PAGE_FEATURE_ANNOUNCEMENT = "ANNOUNCEMENTS";

export const HOME_PAGE_FEATURE_ATTENDANCE = "ATTENDANCE";

export const HOME_PAGE_FEATURE_TIMETABLE = "TIMETABLE";

export const HOME_PAGE_FEATURE_TIMETABLE_MANAGER = "TIMETABLE_MANAGER";

export const HOME_PAGE_FEATURE_CLASSROOM_TODO = "CLASSROOM_TODO";

export const HOME_PAGE_FEATURE_CALENDAR = "CALENDAR";

export const HOME_PAGE_FEATURE_COURSES = "COURSES";

export const HOME_PAGE_FEATURE_FAMILY_COMMUNICATION = "FAMILY_COMMUNICATION";

export const HOME_PAGE_FEATURE_MESSAGING = "MESSAGING";

export const HOME_PAGE_FEATURE_PROGRESS_REPORT = "PROGRESS_REPORT";

export const HOME_PAGE_FEATURE_SNP = "SNP";

export const HOME_PAGE_FEATURE_LEARNER_PORTFOLIO = "LEARNER_PORTFOLIO";

export const HOME_PAGE_FEATURE_EDUCATOR_CENTER = "EDUCATOR_CENTER";

export const HOME_PAGE_FEATURE_GOALS = "GOALS";

export const HOME_PAGE_FEATURE_MB_LIBRARY = "MB_LIBRARY";

export const HOME_PAGE_FEATURE_HOMEROOM = "HOMEROOM";

export const HOME_PAGE_FEATURE_DP_SUBJECT_CENTER = "DP_SUBJECT_CENTER";

export const HOME_PAGE_FEATURE_TODDLE_ANALYTICS = "TODDLE_ANALYTICS";

export const HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT = "BEHAVIOR_MANAGEMENT";

export const HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER = "MB_EDUCATOR_CENTER";

export const HOME_PAGE_FEATURE_MB_CONTENT_SKILLS = "MB_CONTENT_SKILLS";

export const HOME_PAGE_FEATURE_MB_PUBLISH_UNIT = "MB_PUBLISH_UNIT";

export const HOME_PAGE_FEATURE_MCGRAW_HILL_LTI = "MCGRAW_HILL_LTI";

export const HOME_PAGE_PORTFOLIO_REVIEW = "PORTFOLIO_REVIEW";
export const HOME_PAGE_FEATURE_SCHOOL_LIBRARY = "SCHOOL_LIBRARY";
export const HOME_PAGE_THIRD_PARTY_REDIRECT_URL = "THIRD_PARTY_REDIRECT_URL";
export const HOME_PAGE_FEATURE_OAUTH_LOGIN = "OAUTH_LOGIN";
export const ESF_SENTRAL_WELLBEING = "ESF_SENTRAL_WELLBEING";
export const ESF_SENTRAL_ATTENDANCE = "ESF_SENTRAL_ATTENDANCE";
export const ESF_SENTRAL_TIMETABLE = "ESF_SENTRAL_TIMETABLE";
export const ESF_SENTRAL_POLICIES = "ESF_SENTRAL_POLICIES";
export const ESF_SENTRAL_PXP = "ESF_SENTRAL_PXP";
export const ESF_SENTRAL_NEWSFEED = "ESF_SENTRAL_NEWSFEED";
export const ESF_SENTRAL_DAILY_NOTICE = "ESF_SENTRAL_DAILY_NOTICE";

export const HOME_PAGE_FEATURE_PLANNING_INSIGHTS = "PLANNING_INSIGHTS";
export const HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS = "CURRICULUM_INSIGHTS";

export const HOME_PAGE_FEATURE_CURRICULUM_MAPS = "CURRICULUM_MAPS";

export const HOME_PAGE_FEATURE_STUDENT_PLANS = "STUDENT_PLANS";

export const HOME_PAGE_FEATURE_GRADEBOOK = "GRADEBOOK";
export const HOME_PAGE_FEATURE_SAML_PROVIDERS = "SAML_PROVIDERS";
export const HOME_PAGE_POWER_BI_CARD = "HOME_PAGE_POWER_BI_CARD";

export const MODULES_AND_PROJECTS_FEATURES = {
  HOME_PAGE_FEATURE: "HOME_PAGE_FEATURE",
  PROJECT_GROUP: "PROJECT_GROUP",
  THIRD_PARTY_REDIRECT_URL: "THIRD_PARTY_REDIRECT_URL",
  SAML_SP_PROVIDER: "SAML_SP_PROVIDER",
  POWER_BI_CARD: "POWER_BI_CARD",
};
